export const BooleanAttributes = [
  "allowFullScreen",
  "async",
  "autoFocus",
  "autoPlay",
  "checked",
  "compact",
  "contentEditable",
  "controls",
  "declare",
  "default",
  "defer",
  "disabled",
  "formNoValidate",
  "hidden",
  "isMap",
  "itemScope",
  "loop",
  "multiple",
  "muted",
  "noHref",
  "noShade",
  "noValidate",
  "open",
  "playsInline",
  "readonly",
  "required",
  "reversed",
  "scoped",
  "selected",
  "sortable",
  "trueSpeed",
  "typeMustMatch",
  "wmode",
  "autoCapitalize",
  "translate",
  "spellCheck",
  "inert",
  "download",
  "noModule",
  "paused",
  "autoPictureInPicture",
] as const;